export function arrayToLength(array, length) {
  if (array) return array.splice(0, length)
}
